import { render, staticRenderFns } from "./QRCodeWindow.vue?vue&type=template&id=05bdcb1e&"
import script from "./QRCodeWindow.vue?vue&type=script&lang=js&"
export * from "./QRCodeWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports